<template>
  <div>
    <baseEdit />
  </div>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'applicationCreditDetail',
    components: {
      baseEdit,
    },
  };
</script>
